var map = {
	"./alexa.png": "d71c",
	"./bone.png": "77c8",
	"./celular.png": "a3f3",
	"./fritadeira-eletrica.png": "d340",
	"./notebook.png": "2cdb",
	"./panela.png": "a75c",
	"./sanduicheira.png": "a7f3",
	"./tv.png": "97d1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d7b2";